import i18n from "i18n";

export const userMessages = {
  delete: i18n.t('notifications.user.delete'),
  invite: i18n.t('notifications.user.invite'),
  resendInvite: i18n.t('notifications.user.resendInvite'),
  changePassword: i18n.t('notifications.user.changePassword'),
  recoverPassword: i18n.t('notifications.user.recoverPassword')
}